import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MDBDatePickerComponent, ModalDirective, ToastService } from 'ng-uikit-pro-standard';
import { debounceTime, filter } from 'rxjs/operators';
import { CamionSucursalService } from 'src/app/services/camion-sucursal.service';
import { ChoferSucursalService } from 'src/app/services/chofer-sucursal.service';
import { DireccionService } from 'src/app/services/direccion.service';
import { MercaderiaFueraRutaService } from 'src/app/services/mercaderia-fuera-ruta.service';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { TipoIngresoService } from 'src/app/services/tipo-ingreso.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { FileDownloadService } from 'src/app/shared/services/file-download.service';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { RutService } from 'src/app/shared/services/rut.service';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import * as _ from 'lodash'
import { DatesService } from 'src/app/shared/services/dates.service';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { PaginationContext } from 'src/app/shared/object/pagination_context.model';

@Component({
  selector: 'app-retorno-mercaderia-modal-add-edit',
  templateUrl: './modal-add-edit.component.html',
  styleUrls: ['../retorno-mercaderia.component.scss'],
  providers: [SecurityService],
})
export class RetornoMecaderiaComponentModalAddEditComponent implements OnInit {

  mode: 'ADD' | 'VIEW'

  // Outputs
  @Output() onSuccess: EventEmitter<void> = new EventEmitter<void>()

  // Modales
  @ViewChild('agregarRetorno', { static: true }) retornoModal: ModalDirective;
  @ViewChild('datePicker', { static: true }) datePicker: MDBDatePickerComponent
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarProductoComponent, { static: true }) modalSeleccionarProducto: ModalSeleccionarProductoComponent

  // Form
  formHeader: FormGroup
  formProductos: FormGroup

  // Data & Tmp
  public rutEmpresa: number
  public sucursalCodigo: number
  private rutUsuario: number
  enableContent: boolean = true
  mov: any
  listaProductos: Array<any> = []
  listaProductosAll: any[]
  loading: boolean = false
  paginationContext: PaginationContext = new PaginationContext()
  cabeceraCargada: any

  cliente: any = null
  sucursal: any = null
  monto_total: number = 0
  productoSeleccionado: any = null
  tipoIngreso: number | null = null

  optionsChofer: Array<any> = [];
  optionsCamion: Array<any> = [];
  optionsSucursal: Array<any> = [];
  optionsPlaca: Array<any> = [];
  optionsTipoIngreso: Array<any> = [];
  optionsFormato: Array<any> = [];
  optionsTipoMovimiento: Array<any> = [];

  // Utils
  private log: any

  constructor(
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private choferSucursalService: ChoferSucursalService,
    private camionSucursalService: CamionSucursalService,
    private messageRendererService: MessageRendererService,
    private rutService: RutService,
    private direccionService: DireccionService,
    private tipoIngresoService: TipoIngresoService,
    private formValidatorsService: FormValidatorsService,
    private mercaderiaFueraRutaService: MercaderiaFueraRutaService,
    private clog: ConsoleService,
    private toastService: ToastService,
    private fileDownloadService: FileDownloadService,
    private datesService: DatesService,
    private formatoProductoService: FormatoProductosService
  ) {
    this.log = this.clog.log('RETORNO-MERCADERIA-MODAL')
  }

  ngOnInit() {
    this.rutEmpresa = Number(this.accesolocalstorage.getRutEmpresa());
    this.sucursalCodigo = Number(this.accesolocalstorage.getSucursalCodigo());
    this.rutUsuario = Number(this.accesolocalstorage.getRutUsuario())

    this.paginationContext.RecordsByPage = 10

    this.createForms()

    this.loadChofer()
    this.loadCamion()
    this.loadTipoIngreso()

    this.formChangesSubscriptions()
  }

  private createForms() {
    const now = this.datesService.CurrentDateToShortTimeString()

    this.formHeader = this.fb.group({
      chofer: [null, [Validators.required]],
      camion: [null, [Validators.required]],
      fecha: [now],
      rutCliente: [null, [Validators.required]],
      sucursal: [null, [Validators.required]],
      // placa: [null],
      // fichaTecnica: [null],
      tipoIngreso: [null, [Validators.required]],
      glosa: [null],
      totalCabecera: [null]
    });
    this.formProductos = this.fb.group({
      sku: [null, [Validators.required]],
      formato: [null, [Validators.required]],
      cantidad: [null, [Validators.required]],
      precio: [0, [Validators.required]],
      glosa: [null],
      // total: [0]
    });
  }

  loadChofer() {
    const inputParams = {
      entidad: {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        tipobusqueda: 1,
      }
    }
    this.choferSucursalService.obtenerchoferSucursalxRutEmpresaSucursal(inputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
        const { registros } = respuesta; //.registros.filter(p => p.estado);
        this.optionsChofer = registros.map(p => ({ value: p.rut, label: p.nombre, ...p }))
        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('chofer'), this.optionsChofer)
      })
  }

  loadCamion() {
    this.camionSucursalService.obtenerCamionSucursalxRutEmpresaSucursal(
      {
        rut_empresa: this.rutEmpresa,
        sucursal_codigo: this.sucursalCodigo,
        tipobusqueda: 1
      }, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes)
          return
        }
        const { registros } = respuesta; //.registros.filter(p => p.estado);
        this.optionsCamion = registros.map(p => ({ value: p.patente, label: p.descripcion, ...p }))
        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('camion'), this.optionsCamion)
      })
  }

  loadTipoIngreso() {
    this.tipoIngresoService.obtenerTodos(({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      const { registros } = respuesta; //.registros.filter(p => p.estado);
      this.optionsTipoIngreso = registros.map(p => ({ value: p.codigo, label: p.nombre, ...p }))
      this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoIngreso'), this.optionsTipoIngreso)
    })
  }

  formChangesSubscriptions() {
    // if (this.mode === 'ADD')
    this.formHeader.get("rutCliente").valueChanges
      .pipe(filter(Boolean), debounceTime(1000))
      .subscribe((rutCliente: string) => {
        this.modalSeleccionarCliente.searchByRut(rutCliente)
      })

    // if (this.mode === 'ADD')
    this.formHeader.get("sucursal").valueChanges.subscribe(sucursal => {
      this.handleDireccionChange(sucursal)
    })

    if (this.mode === 'ADD')
      this.formHeader.get("tipoIngreso").valueChanges
        .subscribe((tipoIngreso: number) => {
          this.monto_total = 0
          const esTipoIngresoDocumento: boolean = tipoIngreso === 1
          const _control = this.formHeader.get('totalCabecera')
          if (esTipoIngresoDocumento) {
            _control.setValidators([Validators.required, Validators.min(1)])
            _control.updateValueAndValidity()
          } else {
            _control.clearValidators()
            _control.updateValueAndValidity()
          }

          _control.setValue(null)
          _control.markAsUntouched()
          _control.markAsPristine()
        })

    this.formProductos.get("sku").valueChanges
      .pipe(filter(Boolean), debounceTime(500))
      .subscribe((codigo: string) => {
        this.modalSeleccionarProducto.searchBySKU(codigo)
      })

    // this.formProductos.get("cantidad").valueChanges.subscribe(cantidad => {
    //   this.calcularTotalPorProducto()
    // })

    // this.formProductos.get("precio").valueChanges.subscribe(cantidad => {
    //   this.calcularTotalPorProducto()
    // })
  }

  private handleDireccionChange(value) {
    this.sucursal = this.optionsSucursal.filter(p => p.value === value)[0]
  }

  // calcularTotalPorProducto() {
  //   if (!this.formProductos.get("cantidad").value || !this.formProductos.get("precio").value) {
  //     this.monto_total = 0
  //     return
  //   }

  //   try {
  //     const _cantidad = Number(this.formProductos.get("cantidad").value)
  //     const _precio = Number(this.formProductos.get("precio").value)
  //     this.monto_total = _cantidad * _precio
  //   } catch { }
  // }

  showNew() {
    this.mode = 'ADD'
    this.mov = null
    this.reset()
    this.enableContent = true
    this.retornoModal.show()
  }

  showView(mov) {
    this.log(mov)
    this.mode = 'VIEW'
    this.mov = mov
    this.reset()
    this.enableContent = false
    this.obtenerRetornoMercaderiaFueraRuta()
  }

  obtenerRetornoMercaderiaFueraRuta() {
    this.listaProductosAll = null

    const inputParams = {
      rutEmpresa: this.rutEmpresa,
      sucursalCodigo: this.sucursalCodigo,
      codigo: this.mov.codigo
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.loading = true
    this.retornoModal.show()

    this.mercaderiaFueraRutaService.obtenerRetornoMercaderiaFueraRuta(inputParams, ({ mensajes, respuesta }) => {
      const ok = respuesta !== null
      if (!ok) {
        this.messageRendererService.showErrors(mensajes)
        return
      }

      const { cabecera, detalle } = respuesta

      this.cabeceraCargada = cabecera
      this.setDataCabecera()

      // this.paginationContext.RecordsCount = detalle.length //totalRegistros
      // this.paginationContext.PagesCount = this.calculatePageCount()
      // this.paginationContext.CurrentPage = 1 // paginaActual

      this.listaProductosAll = detalle

      this.listaProductosAll.forEach(producto => {
        producto.sku = producto.skuProducto
        producto.descripcion = producto.descripProducto
        producto.formato_nombre = producto.descripFormato
      })

      this.showPage(1)

      this.loading = false
    })
  }

  setDataCabecera() {
    // cabecera
    this.formHeader.get('chofer').setValue(this.cabeceraCargada.chofer_rut)
    this.formHeader.get('camion').setValue(this.cabeceraCargada.camion_patente)
    // this.datePicker.selectDate(this.cabeceraCargada.fecha)
    this.formHeader.get('fecha').setValue(this.cabeceraCargada.fecha)
    this.modalSeleccionarCliente.cleanLast()
    this.formHeader.get('rutCliente').setValue(
      this.rutService.Limpiar(
        this.rutService.AgregarDV(this.cabeceraCargada.cliente_proveedor_rut)
      ))
    this.formHeader.get('tipoIngreso').setValue(this.cabeceraCargada.tipo_ingreso_codigo)
    this.monto_total = this.cabeceraCargada.monto_total
    this.formHeader.get('totalCabecera').setValue(this.cabeceraCargada.monto_total)
    this.formHeader.get('glosa').setValue(this.cabeceraCargada.glosa)
  }

  detallesCleanUp() {
    this.listaProductosAll = null
    this.listaProductos = null
  }

  showPage(pageNumber: number) {
    this.log(`showPage ${pageNumber}`)
    this.log('showPage paginationContext', this.paginationContext)
    this.log('showPage paginationContext', JSON.stringify(this.paginationContext))

    this.setRecordsAndPageCount()
    this.paginationContext.CurrentPage = pageNumber // paginaActual

    this.paginationContext.CurrentPage = pageNumber
    const start = (this.paginationContext.CurrentPage - 1) * this.paginationContext.RecordsByPage
    this.listaProductos = _.slice(this.listaProductosAll, start, start + this.paginationContext.RecordsByPage)
    this.log(`showPage ${this.paginationContext.CurrentPage} from ${start} to ${start + this.paginationContext.RecordsByPage}`, this.listaProductosAll)
    this.log('showPage listaProductos', this.listaProductos)
  }

  setRecordsAndPageCount() {
    this.paginationContext.RecordsCount = this.listaProductosAll.length //totalRegistros
    this.paginationContext.PagesCount = this.calculatePageCount()//Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
  }

  private calculatePageCount(): number {
    this.log('calculatePageCount', this.paginationContext.RecordsCount, this.paginationContext.RecordsByPage, 'result: ', Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage))
    return Math.ceil(this.paginationContext.RecordsCount / this.paginationContext.RecordsByPage) //totalPaginas
  }

  onPageChange(context: PaginationContext) {
    this.showPage(context.RequestedPage)
  }


  reset() {
    this.cabeceraCargada = null

    const now = this.datesService.CurrentDateToShortTimeString()

    this.formValidatorsService.reset(this.formHeader)
    this.datePicker.clearDate()
    this.formHeader.get('fecha').setValue(now)
    this.listaProductos = []
    this.cliente = null
    this.sucursal = null
    this.monto_total = 0
    this.optionsSucursal = []

    this.clearFormProductos()
    this.enableTipoIngreso()
    this.modalSeleccionarProducto.clearLast()
    this.setDefaultComboOptions()

    this.detallesCleanUp()
  }

  clearFormProductos() {
    this.formValidatorsService.reset(this.formProductos)
    this.productoSeleccionado = null
    this.formValidatorsService.resetField(this.formProductos, 'cantidad')
    this.formValidatorsService.resetField(this.formProductos, 'precio')
    this.formValidatorsService.resetField(this.formProductos, 'formato')
    this.optionsFormato = []
  }

  enableTipoIngreso(): void {
    this.formHeader.get('tipoIngreso').enable()
    this.tipoIngreso = null
  }

  disableTipoIngreso(): void {
    this.tipoIngreso = this.formHeader.get('tipoIngreso').value
    this.formHeader.get('tipoIngreso').disable()
  }

  setDefaultComboOptions(): void {
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('chofer'), this.optionsChofer)
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('camion'), this.optionsCamion)
    this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('tipoIngreso'), this.optionsTipoIngreso)
  }

  /********* CLIENTE/SUCURSAL INICIO *********/
  openModalSeleccionarcliente() {
    this.modalSeleccionarCliente.show()
  }

  onClienteSeleccionado({ data, origen }) {
    this.cleanClientDataAndRelated()
    this.cliente = data
    this.cliente.rutFormato = this.rutService.AgregarDV(this.cliente.rut)
    this.formHeader.get('rutCliente').setValue(this.cliente.rutFormato)
    this.fetchSucursal(this.cliente.rut)
  }

  cleanClientDataAndRelated() {
    this.cliente = null

    this.optionsSucursal = []
    this.formHeader.get('rutCliente').markAsPristine()
    this.formHeader.get('rutCliente').markAsUntouched()

    this.formHeader.get('sucursal').setValue(null)
    this.formHeader.get('sucursal').markAsPristine()
    this.formHeader.get('sucursal').markAsUntouched()
  }

  onClienteNoEncontrado() {
    this.cliente = null
    this.cleanClientDataAndRelated()
  }

  private fetchSucursal(cliente_proveedor_rut) {
    const inputParams = {
      empresa_rut: this.rutEmpresa,
      // sucursal_codigo: this.sucursalCodigo,
      cliente_proveedor_rut
    }

    this.direccionService.GetByCliente(inputParams, ({ registros }) => {
      this.optionsSucursal = registros.map(direccion => ({
        value: direccion.codigo,
        label: direccion.nombre,
        ...direccion
      }))
      if (this.mode === 'ADD')
        this.formValidatorsService.selectFirstOrDefault(this.formHeader.get('sucursal'), this.optionsSucursal)
      else if (this.mode === 'VIEW')
        this.formHeader.get('sucursal').setValue(this.cabeceraCargada.direccion_codigo)
    })
  }


  /********* CLIENTE/SUCURSAL INICIO *********/


  /********* PRODUCTO INICIO *********/
  openModalSeleccionarProducto() {
    this.modalSeleccionarProducto.show()
  }

  onProductoSeleccionado({ data: _productoSeleccionado }) {
    this.productoSeleccionado = _productoSeleccionado
    this.formProductos.get('sku').setValue(_productoSeleccionado.sku)

    this.formatoProductoService.GetFormatosByCodigo(
      this.rutEmpresa,
      this.productoSeleccionado.codigo,
      ({ mensajes, respuesta }) => {
        this.optionsFormato = respuesta.registros.map(formato => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }))
        this.formProductos.get('formato').setValue(null)
        this.formValidatorsService.selectDefaultFormatoProducto(this.formProductos.get('formato'), this.optionsFormato)
      }
    )
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null
  }

  esTipoIngresoDocumento(): boolean {
    return this.esTipoIngresoByValue(1)
  }

  esTipoIngresoProducto(): boolean {
    return this.esTipoIngresoByValue(2)
  }

  private esTipoIngresoByValue(value: number): boolean {
    if (this.tipoIngreso)
      return this.tipoIngreso === value
    return this.formHeader.get('tipoIngreso').value === value
  }

  agregarProducto() {
    if (!this.productoSeleccionado) {
      this.toastService.error('Seleccione producto')
      return
    }
    const cantidad: number = Number(this.formProductos.get('cantidad').value)
    const precio: number = Number(this.formProductos.get('precio').value)
    const formato_codigo = this.formProductos.get('formato').value
    const formato_nombre = this.optionsFormato.filter(p => p.value === formato_codigo)[0].formato_nombre

    if (!this.listaProductosAll || this.listaProductosAll.length === 0) this.listaProductosAll = []

    this.listaProductosAll.push({
      sku: this.productoSeleccionado.sku,
      descripcion: this.productoSeleccionado.descripcion,
      cantidad,
      empresa_rut: this.rutEmpresa,
      formato_codigo,
      // glosa: this.esTipoIngresoProducto() ? this.formProductos.get('glosa').value : '',
      glosa: "",
      linea: this.listaProductosAll.length + 1,
      monto_total: precio * cantidad,
      precio_venta: precio,
      producto_codigo: this.productoSeleccionado.codigo,
      formato_nombre
    })

    this.clearFormProductos()
    this.disableTipoIngreso()

    this.modalSeleccionarProducto.clearLast()

    this.setRecordsAndPageCount()
    const lastPage = this.calculatePageCount()
    this.log('lastPage', lastPage)
    this.showPage(lastPage)
    // this.showPage(1)
    this.calcularTotal()

    // this.log('listaProductosAll', this.listaProductosAll)
    // this.log('listaProductos', this.listaProductos)
  }

  calcularTotal() {
    this.monto_total = this.listaProductosAll.map(p => p.monto_total).reduce((prev, next) => prev + next, 0)
  }
  /********* PRODUCTO FIN *********/

  guardar() {
    this.formValidatorsService.validate(this.formHeader)

    if (!this.formHeader.valid)
      return

    if (this.esTipoIngresoProducto() && this.listaProductosAll.length === 0) {
      this.toastService.warning('Agregue productos(s)')
      return
    }

    let detalles = []
    if (this.esTipoIngresoProducto()) {
      detalles = _.cloneDeep(this.listaProductosAll)
      detalles.map(detalle => {
        delete detalle.sku
        delete detalle.descripcion
        delete detalle.formato_nombre
      })
    }

    const inputParams = {
      entidad: {
        cabecera: {
          camion_patente: this.formHeader.get('camion').value,
          chofer_rut: this.formHeader.get('chofer').value,
          cliente_proveedor_rut: this.cliente.rut,
          direccion_codigo: this.sucursal.codigo,
          monto_total: this.esTipoIngresoDocumento() ? Number(this.formHeader.get('totalCabecera').value) : this.monto_total,
          rut_empresa: this.rutEmpresa,
          sucursal_codigo: this.sucursalCodigo,
          tipo_ingreso_codigo: this.formHeader.get('tipoIngreso').value,
          glosa: this.formHeader.get('glosa').value,
          fecha: this.formHeader.get('fecha').value
        },
        detalle: detalles
      },
      rutUsuario: this.rutUsuario
    }

    this.log('inputParams', JSON.stringify(inputParams))

    this.mercaderiaFueraRutaService.grabarRetornoMercaderiaFueraRuta(inputParams, ({ respuesta, mensajes }) => {
      if (mensajes && mensajes.length > 0) {
        this.messageRendererService.showErrors(mensajes)
        return
      }
      this.toastService.success("Operación exitosa")
      this.retornoModal.hide()
      this.onSuccess.emit()
    })
  }

}
